import React from 'react';
import T from 'prop-types';

export const AnchorLink = ({ text, url, className }) => {
    return <>
        <div className={className}>
            <a href={url} target="_blank" className="anchorStyles">
                <span>{text}</span></a>
        </div>
    </>
};

AnchorLink.T = {
    text: T.string,
    className: T.string,

};

AnchorLink.defaultProps = {
    className: "anchorDiv",
};
